import axios from "axios";
import { tmsApi } from "../api";

const getConfig = () => ({
  headers: {
    token: localStorage.getItem("token"),
    "Access-Control-Allow-Origin": "*",
  },
});

/**
 * GET /driver/deductions/settlements/findAll
 * Fetches pending settlements list with optional city/name filters.
 * @param {Object} params - { page, size, serviceCityId?, driverName?, cabNumber? }
 */
export const getPendingSettlements = (params = {}) => {
  const { page = 0, size = 15, serviceCityId, driverName, cabNumber } = params;
  const query = new URLSearchParams({ page, size });
  if (serviceCityId) query.append("serviceCityId", serviceCityId);
  if (driverName) query.append("driverName", driverName);
  if (cabNumber) query.append("cabNumber", cabNumber);

  return axios
    .get(tmsApi + `driver/deductions/settlements/findAll?${query.toString()}`, getConfig())
    .then((resp) => resp)
    .catch((err) => { throw err; });
};

/**
 * GET /driver/deductions/settlements/{driverId}/details
 * Fetches settlement breakdown for a single driver (used in expandable row).
 * @param {number} driverId
 * @param {Object} params - { fromDate, toDate, page, size }
 */
export const getSettlementDetails = (driverId, params = {}) => {
  const { fromDate, toDate, page = 0, size = 15 } = params;
  const query = new URLSearchParams({ page, size });
  if (fromDate) query.append("fromDate", fromDate);
  if (toDate) query.append("toDate", toDate);

  return axios
    .get(tmsApi + `driver/deductions/settlements/${driverId}/details?${query.toString()}`, getConfig())
    .then((resp) => resp)
    .catch((err) => { throw err; });
};

/**
 * GET /driver/deductions/job/findAll
 * Lists all deduction run jobs.
 * @param {Object} params - { page, size, status? }
 */
export const listAllDeductionJobs = (params = {}) => {
  const { page = 0, size = 15, status } = params;
  const query = new URLSearchParams({ page, size });
  if (status) query.append("status", status);

  return axios
    .get(tmsApi + `driver/deductions/job/findAll?${query.toString()}`, getConfig())
    .then((resp) => resp)
    .catch((err) => { throw err; });
};

/**
 * POST /driver/deductions/process
 * Triggers payout deduction processing.
 * @param {Object} body - { fromDate, toDate, serviceCityId, selectAll, driverIds }
 */
export const processPayoutDeduction = (body) => {
  return axios
    .post(tmsApi + `driver/deductions/process`, body, getConfig())
    .then((resp) => resp)
    .catch((err) => { throw err; });
};
